import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { i18nConfig } from './i18n.config';
import { sharedResources } from '../app/i18n';

const resources = {
  en: {
    common: sharedResources.en.common,
    validation: sharedResources.en.validation,
    errors: sharedResources.en.errors,
    auth: sharedResources.en.auth,
  },
  ua: {
    common: sharedResources.ua.common,
    validation: sharedResources.ua.validation,
    errors: sharedResources.ua.errors,
    auth: sharedResources.ua.auth,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...i18nConfig,
    resources,
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'language',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string) =>
        lng.toLowerCase().startsWith('uk') ? 'ua' : lng.split('-')[0],
    },
  });

export default i18n;
